import { QueryKey } from '@/constants/shared';
import { LeaderboardRecord, SeasonOneAllocation } from '@/types';
import { useQuery } from '@tanstack/react-query';
import { makeRequest } from '../network/api';
import { useAuth } from './useAuth';
import { useRole } from './useRole';

// TODO: rename to useCurrentUserStats
// adding in the walletAddress param to allow for fetching data for another user (if admin)
export const useCurrentUserData = (walletAddress?: string | null) => {
  const { isAuthenticated, address, hasCompletedOnboarding, isLoading: isLoadingAuth } = useAuth();
  const { isAdmin } = useRole();

  // if a wallet was passed in and user is admin, fetch that data. else use auth user address
  const fetchWallet = Boolean(walletAddress) && isAdmin ? walletAddress : address;

  const {
    data: currentUserData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [QueryKey.StatsForMe, fetchWallet, isAuthenticated],
    queryFn: async (): Promise<{ stats: LeaderboardRecord; seasonOneAllocation: SeasonOneAllocation } | undefined> => {
      const response = await makeRequest(`stats/wallet?walletAddress=${fetchWallet}`);
      const responseJson = await response.json();
      return responseJson.data;
    },
    enabled: isAuthenticated,
    // this hook mounts every time it's called. don't force refetch or else we don't get caching
    refetchOnMount: false,
  });

  return {
    currentUserData,
    address: fetchWallet as `0x${string}` | undefined,
    isLoading: isLoadingAuth || isLoading,
    isError,
    hasCompletedOnboarding,
  };
};
